import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, info?.componentStack);
  }

  handleReload = () => {
    // Bust any stale cached shell / bundle
    try { window.location.replace(window.location.pathname + "?cb=" + Date.now()); }
    catch { window.location.reload(); }
  };

  render() {
    if (this.state.error) {
      const msg = String(this.state.error?.message || this.state.error || "Error inesperado");
      const isStale = /Unexpected token|Loading chunk|dynamically imported module|ChunkLoadError/i.test(msg);
      return (
        <div className="min-h-[60vh] flex items-center justify-center bg-[#FAFAF7] p-6" data-testid="error-boundary">
          <div className="max-w-md w-full border border-border bg-white rounded-lg p-8 shadow-sm">
            <div className="uppercase-label text-[#8B5A33] mb-2">Madera Blanca Studio</div>
            <h1 className="font-display text-3xl mb-3">Ocurrió un problema</h1>
            <p className="text-sm text-muted-foreground mb-4">
              {isStale
                ? "Parece que tienes una versión guardada en caché. Recarga con Ctrl+Shift+R (o Cmd+Shift+R en Mac) para obtener la última versión."
                : "Recarga la página para intentarlo de nuevo. Si el problema continúa, avisa."}
            </p>
            <pre className="text-xs bg-[#F4F2EC] rounded p-3 max-h-32 overflow-auto text-muted-foreground mb-4" data-testid="error-boundary-detail">{msg}</pre>
            <button
              onClick={this.handleReload}
              className="w-full px-4 py-2 rounded-md bg-[#8B5A33] hover:bg-[#6D4525] text-white text-sm font-medium"
              data-testid="error-boundary-reload"
            >
              Recargar la aplicación
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
